Object.defineProperty(exports, '__esModule', {
  value: true
});
var validate = require('validate.js');
require('lodash.get');
var regex_utils_regexValidator = require('./utils/regexValidator.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var validate__default = /*#__PURE__*/_interopDefaultLegacy(validate);
validate__default['default'].validators.regex = regex_utils_regexValidator.validator;
exports.regexTester = regex_utils_regexValidator.test;